import { render, staticRenderFns } from "./RepairAnalysis.vue?vue&type=template&id=20bf4f04&scoped=true"
import script from "./RepairAnalysis.vue?vue&type=script&lang=js"
export * from "./RepairAnalysis.vue?vue&type=script&lang=js"
import style0 from "./RepairAnalysis.vue?vue&type=style&index=0&id=20bf4f04&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20bf4f04",
  null
  
)

export default component.exports